<template>
    <div :class="view_class_view.form_container">
        <!-- Question 1 -->
        <div :class="view_class_view.input_container">
            <ChooseButton
            :buttons="buttonsCreditOwner"
            :flex="true"
            v-on:choose-button="getValueChooseButtonCreditOwner($event)"
            label="¿El crédito es para usted o para otra persona?"
            />
            <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.credit_owner.$errors" :key="index">
                <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
            </div> 
        </div>
        <!-- End Question 1 -->

        <!-- Form 1-->
        <div v-show="creditOwnerModel.credit_owner == 'otra persona'" class="mt-4" :class="view_class_view.input_container">
            <label class="form-title" for="input_rfc_credit_info"> Propietario Real </label>
            
            <div>
                <input name="input_rfc_credit_info" id="input_rfc_credit_info" type="text"  
                    placeholder="R.F.C."
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.owner_rfc.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.owner_rfc.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.owner_rfc.$invalid && !creditOwnerModelValidations.owner_rfc.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.owner_rfc.$model"/>
                
                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.owner_rfc.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div>
                <input name="input_curp_credit_info" id="input_curp_credit_info" type="text"  
                    placeholder="C.U.R.P."
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.owner_curp.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.owner_curp.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.owner_curp.$invalid && !creditOwnerModelValidations.owner_curp.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.owner_curp.$model"/>
                
                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.owner_curp.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div>
                <input name="input_name_credit_info" id="input_name_credit_info" type="text"  
                    placeholder="Primer nombre"
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.owner_first_name.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.owner_first_name.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.owner_first_name.$invalid && !creditOwnerModelValidations.owner_first_name.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.owner_first_name.$model"/>

                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.owner_first_name.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>

            <div>
                <input name="input_second_name_credit_info" id="input_second_name_credit_info" type="text"  
                    placeholder="Segundo nombre"
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.owner_second_name.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.owner_second_name.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.owner_second_name.$invalid && !creditOwnerModelValidations.owner_second_name.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.owner_second_name.$model"/>

                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.owner_second_name.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
            
            <div>
                <input name="input_paternal_last_name_credit_info" id="input_paternal_last_name_credit_info" type="text"  
                    placeholder="Apellido Paterno"
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.owner_paternal_name.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.owner_paternal_name.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.owner_paternal_name.$invalid && !creditOwnerModelValidations.owner_paternal_name.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.owner_paternal_name.$model"/>
                
                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.owner_paternal_name.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
            
            <div>
                <input name="input_mother_last_name_credit_info" id="input_mother_last_name_credit_info" type="text"  
                    placeholder="Apellido Materno"
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.owner_maternal_name.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.owner_maternal_name.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.owner_maternal_name.$invalid && !creditOwnerModelValidations.owner_maternal_name.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.owner_maternal_name.$model"/>

                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.owner_maternal_name.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
            
            <div class="mt-4">
                <ChooseButton
                    :buttons="buttonsOwnerGenders"
                    :flex="true"
                    v-on:choose-button="getValueChooseButtonOwnerGender($event)"
                    label="Género:"
                    />

                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.owner_gender.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
            
            <div class="my-4">
                <label> Lugar de nacimiento: </label>
                <BirthPlace ref="OwnerBirthPlaceRef" :key_token_storage="'login'" :urlAPI="'http://200.92.206.58:8080'" :view_class_view="view_class_view_birth_place" :validations="validations_birth_place_owner"/>
            </div>
            
            <label class="font-bold" for="input_credit_owner_owner_contact_email"> Contacto </label>

            <div>
                <input name="input_email_contact_credit" id="input_email_contact_credit" type="text"  
                    placeholder="Correo Electrónico"
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.owner_contact_email.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.owner_contact_email.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.owner_contact_email.$invalid && !creditOwnerModelValidations.owner_contact_email.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.owner_contact_email.$model"/>

                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.owner_contact_email.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>       

            <div>
                <input name="input_cellphone_contact_credit" id="input_cellphone_contact_credit" type="text"  
                    placeholder="Celular"
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.owner_contact_cellphone.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.owner_contact_cellphone.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.owner_contact_cellphone.$invalid && !creditOwnerModelValidations.owner_contact_cellphone.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.owner_contact_cellphone.$model"/>

                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.owner_contact_cellphone.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>

            <div>
                <input name="input_phone_contact_credit" id="input_phone_contact_credit" type="text"  
                    placeholder="Teléfono Fijo"
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.owner_contact_telephone.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.owner_contact_telephone.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.owner_contact_telephone.$invalid && !creditOwnerModelValidations.owner_contact_telephone.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.owner_contact_telephone.$model"/>
                    
                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.owner_contact_telephone.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
            
        </div>
        <!-- End Form 1 -->

        <!-- Question 2 -->
        <div class="mt-8" :class="view_class_view.input_container">
            <ChooseButton
            :buttons="buttonsWhoWillPay"
            :flex="true"
            v-model="creditOwnerModelValidations.payer"
            v-on:choose-button="getValueChooseButtonPayer($event)"
            label="¿El crédito será pagado por usted o para otra persona?"
            />
            <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.payer.$errors" :key="index">
                <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
            </div> 
        </div>
        <!-- End Question 2 -->

        <!-- Form 2 -->
        <div v-show="creditOwnerModel.payer == 'otra persona'" class="mt-4" :class="view_class_view.input_container">
            <label class="form-title" for="input_payer_rfc"> Propietario Real </label>
            
            <div>
                <input name="input_rfc_credit_payment" id="input_rfc_credit_payment" type="text"  
                    placeholder="R.F.C."
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.payer_rfc.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.payer_rfc.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.payer_rfc.$invalid && !creditOwnerModelValidations.payer_rfc.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.payer_rfc.$model"/>
                
                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.payer_rfc.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div>
                <input name="input_curp_credit_payment" id="input_curp_credit_payment" type="text"  
                    placeholder="C.U.R.P."
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.payer_curp.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.payer_curp.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.payer_curp.$invalid && !creditOwnerModelValidations.payer_curp.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.payer_curp.$model"/>
                
                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.payer_curp.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div>
                <input name="input_name_credit_payment" id="input_name_credit_payment" type="text"  
                    placeholder="Primer nombre"
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.payer_first_name.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.payer_first_name.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.payer_first_name.$invalid && !creditOwnerModelValidations.payer_first_name.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.payer_first_name.$model"/>

                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.payer_first_name.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>

            <div>
                <input name="input_second_name_credit_payment" id="input_second_name_credit_payment" type="text"  
                    placeholder="Segundo nombre"
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.payer_second_name.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.payer_second_name.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.payer_second_name.$invalid && !creditOwnerModelValidations.payer_second_name.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.payer_second_name.$model"/>

                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.payer_second_name.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
            
            <div>
                <input name="input_paternal_last_name_credit_payment" id="input_paternal_last_name_credit_payment" type="text"  
                    placeholder="Apellido Paterno"
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.payer_paternal_name.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.payer_paternal_name.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.payer_paternal_name.$invalid && !creditOwnerModelValidations.payer_paternal_name.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.payer_paternal_name.$model"/>
                
                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.payer_paternal_name.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
            
            <div>
                <input name="input_mother_last_name_credit_payment" id="input_mother_last_name_credit_payment" type="text"  
                    placeholder="Apellido Materno"
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.payer_maternal_name.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.payer_maternal_name.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.payer_maternal_name.$invalid && !creditOwnerModelValidations.payer_maternal_name.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.payer_maternal_name.$model"/>

                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.payer_maternal_name.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
            
            <div class="mt-4">
                <ChooseButton
                    :buttons="buttonsPayerGenders"
                    :flex="true"
                    v-on:choose-button="getValueChooseButtonPayerGender($event)"
                    label="Género:"
                    />

                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.payer_gender.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
            
            <div class="my-4">
                <label> Lugar de nacimiento: </label>
                <BirthPlace ref="PayerBirthPlaceRef" :key_token_storage="'login'" :urlAPI="'http://200.92.206.58:8080'" :view_class_view="view_class_view_birth_place" :validations="validations_birth_place_payer"/>
            </div>
            
            <label class="font-bold" for="input_payer_payer_contact_email"> Contacto </label>

            <div>
                <input name="input_email_contact_credit_payment" id="input_email_contact_credit_payment" type="text"  
                    placeholder="Correo Electrónico"
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.payer_contact_email.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.payer_contact_email.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.payer_contact_email.$invalid && !creditOwnerModelValidations.payer_contact_email.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.payer_contact_email.$model"/>

                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.payer_contact_email.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>       

            <div>
                <input name="input_cellphone_contact_credit_payment" id="input_cellphone_contact_credit_payment" type="text"  
                    placeholder="Celular"
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.payer_contact_cellphone.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.payer_contact_cellphone.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.payer_contact_cellphone.$invalid && !creditOwnerModelValidations.payer_contact_cellphone.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.payer_contact_cellphone.$model"/>

                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.payer_contact_cellphone.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>

            <div>
                <input name="input_phone_contact_credit_payment" id="input_phone_contact_credit_payment" type="text"  
                    placeholder="Teléfono Fijo"
                    :class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: creditOwnerModelValidations.payer_contact_telephone.$error,
                    [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!creditOwnerModelValidations.payer_contact_telephone.$invalid,
                    [view_class_view.class_inputs.default ]: creditOwnerModelValidations.payer_contact_telephone.$invalid && !creditOwnerModelValidations.payer_contact_telephone.$error  }"
                    class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" 
                    v-model.trim="creditOwnerModelValidations.payer_contact_telephone.$model"/>
                    
                <div :class="view_class_view.div_container_error.container" v-for="(error, index) of creditOwnerModelValidations.payer_contact_telephone.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
            
        </div>
        <!-- End Form 2 -->

    </div>
</template>

<script>

import { ref } from 'vue';
import useVuelidate from "@vuelidate/core";
import ChooseButton from "./Forms/ChooseButton.vue";
import BirthPlace from "./BirthPlace.vue";

export default {
    name: 'CreditOwnerComponent',
    props: {
        validations: {
            type: Object,
            default(){
                return {};
            }
        },
        validations_birth_place_owner: {
            type: Object,
            default(){
                return {};
            }
        },
        validations_birth_place_payer: {
            type: Object,
            default(){
                return {};
            }
        },
        view_class_view: {
            type: Object,
            default(){
                return {};
            }
        }
    },
    setup(props){
        const buttonsCreditOwner = ref([
            { id: "button_credit_for_me", value: "para mí", text: "Para mí" },
            { id: "button_credit_for_other_person", value: "otra persona", text: "Otra persona" }
        ]);

        const buttonsWhoWillPay = ref([
            { id: "button_me_credit_payment", value: "por mí", text: "Por mí" },
            { id: "button_other_person_credit_payment", value: "otra persona", text: "Otra persona" }
        ]);

        const buttonsOwnerGenders = ref([
            { id: "button_gender_female_credit_info", value: "mujer", text: "Mujer" },
            { id: "button_gender_man_credit_info", value: "hombre", text: "Hombre" },
        ]);

        const buttonsPayerGenders = ref([
            { id: "button_gender_female_credit_payment", value: "mujer", text: "Mujer" },
            { id: "button_gender_man_credit_payment", value: "hombre", text: "Hombre" },
        ]);

        const OwnerBirthPlaceRef = ref(null);

        const PayerBirthPlaceRef = ref(null);
        
        const view_class_view_birth_place = {
            classInputs:{
                valid:"border-blue-600",
                no_valid:"border-red-600",
                default:"w-full py-2 px-2 rounded-md border-2 border-sm focus:border-blue-600 mb-2 mt-2 shadow-md focus:outline-none "
            },
            div_container_error:{
                container:"my-2",
                text_error:"text-red-600",
            },
            div_container:"flex flex-wrap mb-6 mt-4",
            choose_button_nacionality:"flex flex-wrap w-full inline md:w-1/3 mb-6 md:mb-6",
            div_conatiner_states:"w-full md:w-1/3 mb-6 md:mb-6",
            div_conatiner_municipalities:"w-full md:w-1/3 mb-6 md:mb-6",
            div_conatiner_cities:"w-full md:w-1/3 mb-6 md:mb-6"
        };

        let creditOwnerModel = ref({payer:"", credit_owner:"", owner_rfc: "", owner_curp: "", owner_first_name: "", owner_second_name: "", owner_maternal_name: "", owner_paternal_name: "", owner_gender: "", owner_contact_email: "", owner_contact_cellphone: "", owner_contact_telephone: "", payer_rfc: "", payer_curp: "", payer_first_name: "", payer_second_name: "", payer_maternal_name: "", payer_paternal_name: "", payer_gender: "", payer_contact_email: "", payer_contact_cellphone: "", payer_contact_telephone: ""});
        let creditOwnerModelValidations = useVuelidate(props.validations, creditOwnerModel);

        function getValueChooseButtonCreditOwner(value){
            creditOwnerModelValidations.value.credit_owner.$model = value;
        }

        function getValueChooseButtonPayer(value){
            creditOwnerModelValidations.value.payer.$model = value;
        }

        function getValueChooseButtonOwnerGender(value){
            creditOwnerModelValidations.value.owner_gender.$model = value;
        }

        function getValueChooseButtonPayerGender(value){
            creditOwnerModelValidations.value.payer_gender.$model = value;
        }

        function execute_validation(){
            let payerBirthPlaceValidation = PayerBirthPlaceRef.value.execute_validation();
            let ownerBirthPlaceValidation = OwnerBirthPlaceRef.value.execute_validation();
            
             creditOwnerModelValidations.value.$validate();
            if(creditOwnerModelValidations.value.$error || !payerBirthPlaceValidation || !ownerBirthPlaceValidation){
                return false;
            }
            
            creditOwnerModel.value.owner_birth_place = ownerBirthPlaceValidation;
            creditOwnerModel.value.payer_birth_place = payerBirthPlaceValidation;
            return creditOwnerModel.value;
        }

        return {
            buttonsCreditOwner,
            buttonsWhoWillPay,
            buttonsOwnerGenders,
            buttonsPayerGenders,
            creditOwnerModel,
            creditOwnerModelValidations,
            getValueChooseButtonCreditOwner,
            getValueChooseButtonPayer,
            getValueChooseButtonOwnerGender,
            getValueChooseButtonPayerGender,
            view_class_view_birth_place,
            OwnerBirthPlaceRef,
            PayerBirthPlaceRef,
            execute_validation
        };
    },
    components: {
        ChooseButton,
        BirthPlace
    }
}

</script>

<style scoped>
label {
    font-style: normal;
    font-weight: 300;
    font-size: 19px;
    line-height: 26px;
    color: #485462;
}

.form-title {
    font-style: normal;
    font-weight: 400;
    font-size: 19px;
    line-height: 26px;
    color:#485462;
}
.text-label {
    font-style: normal;
    font-weight: 500;
    font-size: 19px;
    line-height: 36px;
    color: #485462;
}
</style>

<style>
p.label-input {
    font-style: normal;
    font-weight: 300;
    font-size: 19px;
    line-height: 26px;
    color: #485462;
}
label {
    font-style: normal;
    font-weight: 300;
    font-size: 19px;
    line-height: 26px;
    color: #485462;
}
</style>